import type { Topic } from "../types"
import { TopicIcon } from "./TopicIcons"

interface TopicListProps {
	topics: Topic[]
	onSelect: (topic: Topic) => void
	disabled?: boolean
	// KidHome passes a single group and titles the section itself, so the
	// group's own heading would only repeat what is already above the tiles.
	hideGroupHeadings?: boolean
}

function groupTopics(topics: Topic[]): [string, Topic[]][] {
	const groups = new Map<string, Topic[]>()
	for (const t of topics) {
		const arr = groups.get(t.group)
		if (arr) {
			arr.push(t)
		} else {
			groups.set(t.group, [t])
		}
	}
	return Array.from(groups.entries())
}

// The topic picker: a grid of tiles, icon over name, grouped under a small
// caps label. Tiles wrap to however many columns fit, so a phone gets two
// and a laptop five without a breakpoint.
export function TopicList({
	topics,
	onSelect,
	disabled,
	hideGroupHeadings,
}: TopicListProps) {
	const groups = groupTopics(topics)
	return (
		<div class="stack gap-4">
			{groups.map(([group, items]) => (
				<div class="stack gap-2" key={group}>
					{!hideGroupHeadings && <div class="eyebrow">{group}</div>}
					<div class="topic-grid">
						{items.map((t) => (
							<button
								type="button"
								key={t.id}
								class="tile"
								disabled={disabled}
								onClick={() => onSelect(t)}
							>
								<TopicIcon topic={t.id} />
								<span>{t.name}</span>
							</button>
						))}
					</div>
				</div>
			))}
		</div>
	)
}
